/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-2",
    "aws_appsync_graphqlEndpoint": "https://2boftl5q4bbcjboepp5ub2o72m.appsync-api.us-east-2.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-2",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-wmb3f5u6gjhzbfmnihhwtq626a",
    "aws_cloud_logic_custom": [
        {
            "name": "apiFrontEnd",
            "endpoint": "https://cuqc96qz35.execute-api.us-east-2.amazonaws.com/staging",
            "region": "us-east-2"
        }
    ],
    "aws_cognito_identity_pool_id": "us-east-2:5d29f12d-59b6-4fd0-a8c3-6325e8107a85",
    "aws_cognito_region": "us-east-2",
    "aws_user_pools_id": "us-east-2_LTlIn6dMw",
    "aws_user_pools_web_client_id": "3htdi1c0oeumpifj0da4vcrfab",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": [
            "REQUIRES_LOWERCASE",
            "REQUIRES_NUMBERS",
            "REQUIRES_SYMBOLS",
            "REQUIRES_UPPERCASE"
        ]
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "geo": {
        "amazon_location_service": {
            "region": "us-east-2",
            "maps": {
                "items": {
                    "SiteMap-staging": {
                        "style": "VectorEsriStreets"
                    }
                },
                "default": "SiteMap-staging"
            }
        }
    }
};


export default awsmobile;
